<template>
  <div class="con-main-nav">
    <div class="con-main-navs">
      <div class="con-main-navs-title">
        <span class="con-main-navs-title-wz">报刊矩阵</span>
        <span class="con-main-navs-title-en">NEWSPAPER MATRIX</span>
      </div>
      <!-- 导航为链接 -->
      <div class="con-main-navs-st">
        <div
          class="con-main-navs-st-list-new"
          v-for="(item, key) in navlist"
          :key="key"
          @click="clickpapernav(item)"
          :title="item.title"
        >
          <el-image
            style="width: 262px; height: 93px"
            :src="item.url"
          ></el-image>
        </div>
      </div>

      <!-- 导航为文章详情 -->
      <!-- <div class="con-main-navs-st">
        <div
          :class="item.classname"
          v-for="(item, key) in papernavlist"
          :key="key"
          @click="clickpapernav(item.dflid, item.index, item.ison)"
        >
          <div class="con-main-navs-st-list-wz">{{ item.name }}</div>
          <div class="con-main-navs-st-list-en">{{ item.en }}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
// router
import { useRouter } from "vue-router";
const router = useRouter();
// vuex
import { useStore } from "vuex";
const store = useStore();
// 导航为链接
const navlist = reactive([
  {
    url: require("@/assets/img/lanmunva/nav-01.jpg"),
    path: "/jyyj/list",
    idx: 2,
    dflid: 1,
    title:"大学"
  },
  {
    url: require("@/assets/img/lanmunva/nav-02.jpg"),
    path: "/kjts/list",
    idx: 3,
    dflid: 2,
    title:"电脑迷"
  },
  {
    url: require("@/assets/img/lanmunva/nav-03.jpg"),
    path: "/kjts/list",
    idx: 3,
    dflid: 2,
    title:"科研成果与传播"
  },
  {
    url: require("@/assets/img/lanmunva/nav-04.jpg"),
    path: "/jkkp/list",
    idx: 4,
    dflid: 3,
    title:"健康人报"
  },
  {
    url: require("@/assets/img/lanmunva/nav-05.jpg"),
    path: "/szyt/list",
    idx: 5,
    dflid: 4,
    title:"大中小学思政课一体化研究与实践"
  },
  {
    url: require("@/assets/img/lanmunva/nav-06.jpg"),
    path: "/xljj/list",
    idx: 7,
    dflid: 6,
    title:"培根铸魂 启智润心"
  },
  {
    url: require("@/assets/img/lanmunva/nav-07.jpg"),
    path: "/xxfz/list",
    idx: 8,
    dflid: 7,
    title:"66个班级管理实用巧招"
  },
  {
    url: require("@/assets/img/lanmunva/nav-08.jpg"),
    path: "/xxfz/list",
    idx: 8,
    dflid: 7,
    title:"可以复制的校长领导力"
  },
]);

// 点击
const clickpapernav = (data) => {
  router.push({
    path: data.path,
    query: {
      idx: data.idx,
      dflid: data.dflid,
    },
  });
};

// 导航为文章详情
// const papernavlist = reactive([
//   {
//     name: "· 教育研究",
//     en: "EDUCATE",
//     dflid: 1,
//     index: 2,
//     ison: true, //是否启用
//     classname: "con-main-navs-st-list", //未选择con-main-navs-st-list  选择con-main-navs-st-list-active
//   },
//   {
//     name: "· 科技探索",
//     en: "TECHNOLOGY",
//     dflid: 2,
//     index: 3,
//     ison: true,
//     classname: "con-main-navs-st-list", //未选择con-main-navs-st-list  选择con-main-navs-st-list-active
//   },
//   {
//     name: "· 健康科普",
//     en: "HEALTHY",
//     dflid: 3,
//     index: 4,
//     ison: true,
//     classname: "con-main-navs-st-list", //未选择con-main-navs-st-list  选择con-main-navs-st-list-active
//   },
//   {
//     name: "· 思政一体",
//     en: "THOUGHT",
//     dflid: 4,
//     index: 5,
//     ison: true,
//     classname: "con-main-navs-st-list", //未选择con-main-navs-st-list  选择con-main-navs-st-list-active
//   },
//   {
//     name: "· 美育融合",
//     en: "AESTHETIC",
//     dflid: 5,
//     index: 6,
//     ison: false,
//     classname: "con-main-navs-st-list", //未选择con-main-navs-st-list  选择con-main-navs-st-list-active
//   },
//   {
//     name: "· 心理聚焦",
//     en: "PSYCHOLOGY",
//     dflid: 6,
//     index: 7,
//     ison: true,
//     classname: "con-main-navs-st-list", //未选择con-main-navs-st-list  选择con-main-navs-st-list-active
//   },
//   {
//     name: "· 学校发展",
//     en: "SCHOOL",
//     dflid: 7,
//     index: 8,
//     ison: true,
//     classname: "con-main-navs-st-list", //未选择con-main-navs-st-list  选择con-main-navs-st-list-active
//   },
// ]);
// // 大分类id
// let dafxid = ref("");
// dafxid.value = parseInt(router.currentRoute.value.query.dflid);
// // 更改选中以及未开放置灰
// papernavlist.forEach((e) => {
//   if (dafxid.value === e.dflid) {
//     e.classname = "con-main-navs-st-list con-main-navs-st-list-active";
//   }
//   if(!e.ison){
//     e.classname = "con-main-navs-st-list con-main-navs-st-list-hui";
//   }
// });
// // 点击导航
// const clickpapernav = (fenleiid, navindex, iss) => {
//   if (iss) {
//     // 重置临时页码
//     store.commit("updatepageindextemp",1)
//     router.push({
//       path: "/paper/list",
//       query: {
//         idx: navindex, //导航索引
//         dflid: fenleiid, //大分类id
//       },
//     });
//   } else {
//     ElMessage({
//       message: "暂未开放",
//       type: "info",
//     });
//   }
// };
</script>

<style scoped>
.con-main-nav {
  float: left;
  width: 270px;
  margin-top: 40px;
  height: auto;
}
.con-main-navs {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.con-main-navs-title {
  width: 100%;
  height: 80px;
  background-image: url("../../assets/img/hdzq/nav.jpg");
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.con-main-navs-st-list {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.con-main-navs-st-list:hover {
  background: #fafafa;
}
.con-main-navs-title-wz {
  font-weight: bold;
  font-size: 20px;
}
.con-main-navs-title-en {
  font-size: 14px;
  padding-top: 5px;
}
.con-main-navs-st-list-wz {
  width: 100px;
  display: block;
}
.con-main-navs-st-list-en {
  width: 100px;
  display: block;
  font-size: 12px;
  padding-left: 25px;
  padding-top: 5px;
}
.con-main-navs-st-list-active {
  color: #296fab;
  cursor: default;
  background: #fafafa;
}
.con-main-navs-st-list-hui {
  color: #999;
}

.con-main-navs-st-list-new {
  width: 100%;
  height: 100px;
  padding: 3px;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
  background: #fff;
}
.con-main-navs-st-list-new:hover {
  background: #ccc;
}
</style>
